import React from "react";
import SelectMenu from "@lululemon/ecom-common/src/components/select-menu/select-menu";

// Styles
import styles from "./Menu.module.scss";

interface MenuProps {
  label: string;
  options: SortOption[];
  onChange: (selectedOption: { label: string; key: string }) => void;
}

/**
 * Renders a menu component with selectable options.
 *
 * @component
 * @param {MenuProps} props - The props for the Menu component.
 * @returns {JSX.Element|null} The rendered component or null if there are no options.
 */
export const Menu: React.FC<MenuProps> = React.memo(
  ({ options, label, onChange }: MenuProps) => {
    if (options.length === 0) return null;
    const selectedOption = options.find((option) => option.selected);

    return (
      <div className={`${styles.menuWrapper} ${styles.paddingZero} col-md-5`}>
        <div className={`${styles.menuContainer} col-md-9`}>
          <SelectMenu
            title={label}
            default={selectedOption?.label}
            subtitle={selectedOption?.label}
            options={options}
            callback={onChange}
          />
        </div>
      </div>
    );
  }
);

Menu.displayName = "Menu";
